<template>
  <div class="regist-page">
    <div class="chose-box" v-if="form.userType === 0">
      <div class="head">
        <p class="title">请选择注册的账号类型</p>
        <p>
          已有库蜂网账号？
          <button
            class="common-btn-text"
            @click="$router.replace('./regist?login=true')"
          >快捷登录</button>
        </p>
      </div>
      <div class="content">
        <div>
          <div class="flex" @click="form.userType=4">
            <img src="../../assets/regist/person.png" />
            <p class="title">注册个人客户</p>
          </div>
          <p>可以浏览及购买所有产品并享受消费积分优惠，适合个人用户注册</p>
        </div>
        <div>
          <div class="flex" @click="form.userType=3">
            <img src="../../assets/regist/qiye.png" />
            <p class="title">注册企业客户</p>
          </div>
          <p>具有大批量采购与提供业务服务的能力，可享受集采价格，并可在线制作Excel及PPT方案，适合企业及组织注册</p>
        </div>
      </div>
    </div>
    <div class="form" v-else-if="form.userType==4">
      <div class="head">
        <p class="title">个人用户注册</p>
        <p>
          已有库蜂网账号？
          <button
            class="common-btn-text"
            @click="$router.replace('./regist?login=true')"
          >快捷登录</button>
        </p>
      </div>
      <el-form :rules="rules" ref="form" label-position="right" label-width="30%" :model="form">
        <el-form-item label="账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入账号名称"></el-input>
        </el-form-item>
        <el-form-item label="设置密码" prop="password">
          <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repwd">
          <el-input type="password" v-model="form.repwd" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="telphone">
          <el-input
            :maxlength="11"
            v-model="form.telphone"
            placeholder="请输入手机号"
            style="width:60%;"
          ></el-input>
          <button
            type="button"
            @click="getCheckCode"
            style="margin-left: 8px"
            class="common-btn"
          >获取验证码</button>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="form.checkCode" placeholder="请输入手机短信验证码"></el-input>
        </el-form-item>
        <el-form-item label="证件类型">
          <el-select v-model="form.idType">
            <el-option :value="1" label="身份证"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="idNumber">
          <el-input v-model="form.idNumber" :maxlength="24" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item label="证件照片">
          <!-- <el-input v-model="form.idPath" placeholder="请上传证件照片"></el-input> -->
          <el-upload
            class="avatar-uploader"
            :action="fileUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="form.idPath" :src="form.idPath" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="通讯地址">
          <el-input v-model="form.address" placeholder="请输入通讯地址"></el-input>
        </el-form-item>
        <el-form-item label style="height: 20px;">
          <div style="line-height: 1">
            <el-checkbox v-model="isRead" /> 我已阅读并接受
            <button type="button" class="common-btn-text">《库蜂网用户协议》</button>
          </div>
        </el-form-item>
        <el-form-item>
          <button
            type="button"
            :disabled="!isRead"
            style="width: 420px;height: 39px;font-size:18px;border-radius: 4px"
            class="common-btn"
            @click="submitForm('form')"
          >立即注册</button>
        </el-form-item>
      </el-form>
    </div>
    <div class="form" v-else-if="form.userType==3">
      <div class="title-img"><img src="@/assets/regist-1.png" width="420" alt=""></div>
      <div class="head">
        <p class="title"></p>
        <p>
          已有库蜂网账号？
          <button
            class="common-btn-text"
            @click="$router.replace('./regist?login=true')"
          >快捷登录</button>
        </p>
      </div>
      <el-form
        :rules="companyRules"
        ref="form"
        label-position="right"
        label-width="30%"
        :model="form"
      >
        <el-form-item label="管理员账号" prop="username">
          <el-input v-model="form.username" placeholder="请输入账号名称"></el-input>
        </el-form-item>
        <el-form-item label="设置密码" prop="password">
          <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repwd">
          <el-input type="password" v-model="form.repwd" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="telphone">
          <el-input
            :maxlength="11"
            v-model="form.telphone"
            placeholder="请输入手机号"
            style="width: 60%;"
          ></el-input>
          <button
            type="button"
            @click="getCheckCode"
            style="margin-left: 8px;border-radius: 4px;"
            class="common-btn"
            :disabled="state.smsSendBtn"
            @click.stop.prevent="getCheckCode"
            v-text="!state.smsSendBtn && '获取验证码' || (state.time+' s')">
          >获取验证码</button>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="form.checkCode" placeholder="请输入手机短信验证码"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="linkman">
          <el-input v-model="form.linkman" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <!-- <el-form-item label="昵称" prop="name">
          <el-input v-model="form.name" placeholder="请输入昵称"></el-input>
        </el-form-item>-->
        <el-form-item label="企业名称" prop="company">
          <el-input v-model="form.company" placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item label="营业执照号码" prop="idNumber">
          <el-input v-model="form.idNumber" :maxlength="40" placeholder="请输入营业执照号码"></el-input>
        </el-form-item>
        <el-form-item label="证件照片">
          <!-- <el-input v-model="form.idPath" placeholder="请上传证件照片"></el-input> -->
          <el-upload
            class="avatar-uploader"
            :action="fileUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="form.idPath" :src="form.idPath" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="通讯地址">
          <el-input v-model="form.address" placeholder="请输入通讯地址"></el-input>
        </el-form-item>
        <el-form-item label style="height: 20px;">
          <div style="line-height: 1">
            <el-checkbox v-model="isRead" /> 我已阅读并接受
            <button type="button" class="common-btn-text">《库蜂网用户协议》</button>
          </div>
        </el-form-item>
        <el-form-item>
          <button
            type="button"
            :disabled="!isRead"
            style="width: 420px;height: 39px;font-size:18px;border-radius: 4px;"
            class="common-btn"
            @click="submitForm('form')"
          >立即注册</button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getCheckCode,
  register,
  upload,
  fileUrl,
  checkUsername,
  checkTelphone
} from "@/js/api";
import { IP } from "@/js/public";

export default {
  name: "UserHome",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.repwd !== "") {
          this.$refs.form.validateField("repwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkTel = (rule, value, callback) => {
      checkTelphone({
        telphone: value
      }).then(res => {
        if (res.code == 0) {
          callback();
        } else {
          callback(new Error("手机号已注册"));
        }
      });
    };
    var checkName = (rule, value, callback) => {
      checkUsername({
        username: value
      }).then(res => {
        if (res.code == 0) {
          callback();
        } else {
          callback(new Error("账户名已注册"));
        }
      });
    };
    var checkPassword = (rule, value, callback) => {
      var reg = new RegExp(
        /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/
      );
      if (!reg.test(value))
        callback(new Error("请输入带有大小写英文和数字的密码"));
      else callback();
    };
    return {
      fileUrl,
      isRead: false,
      state: {
        time: 300,
        smsSendBtn: false,
      },
      form: {
        userType: 3,
        username: "",
        password: "",
        repwd: "",
        idType: 1
      },
      rules: {
        username: [
          { required: true, message: "请输入账号名", trigger: "blur" },
          { min: 5, message: "长度在 5 个字符以上", trigger: "blur" },
          { validator: checkName, trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
          { validator: checkPassword, trigger: "change" }
        ],
        repwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" }
        ],
        telphone: [
          { required: true, message: "请输入11位手机号", trigger: "change" },
          { min: 11, max: 11, message: "请输入11位手机号", trigger: "blur" },
          { validator: checkTel, trigger: "blur" }
        ],
        checkCode: [
          { required: true, message: "请输入手机短信验证码", trigger: "change" }
        ],
        idNumber: [
          { required: true, message: "请输入证件号码", trigger: "change" }
        ]
      },
      companyRules: {
        username: [
          { required: true, message: "请输入账号名", trigger: "blur" },
          { min: 5, message: "长度在 5 个字符以上", trigger: "blur" },
          { validator: checkName, trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
          { validator: checkPassword, trigger: "change" }
        ],
        repwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" }
        ],
        telphone: [
          { required: true, message: "请输入11位手机号", trigger: "change" },
          { min: 11, max: 11, message: "请输入11位手机号", trigger: "blur" },
          { validator: checkTel, trigger: "blur" }
        ],
        checkCode: [
          { required: true, message: "请输入手机短信验证码", trigger: "change" }
        ],
        linkman: [
          { required: true, message: "请输入联系人", trigger: "change" }
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "change" }],
        company: [
          { required: true, message: "请输入公司名称", trigger: "change" }
        ],
        idNumber: [
          { required: true, message: "请输入营业执照号码", trigger: "change" }
        ]
      },
      telFlag: true
    };
  },
  methods: {
    uploadFile(e) {
      var formData = new FormData();
      formData.set("file", e.file);
      formData.set("type", "commodity");
      upload(formData).then(res => {
        if (res.code == "200") {
          this.$message.warn("图片上传成功！");
          e.onSuccess();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.form.idPath = IP + "/kufeng-admin/" + res.result;
        this.$forceUpdate();
      }
      // this.form.idPath = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    getCheckCode() {
      if (this.form.telphone) {
        getCheckCode({
          telphone: this.form.telphone,
          type: 'REGISTER'
        }).then(res => {
          if (res.code == 0) {
            this.state.smsSendBtn = true;
            let interval = window.setInterval(() => {
              if (this.state.time-- <= 0) {
                this.state.time = 300;
                this.state.smsSendBtn = false;
                window.clearInterval(interval);
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          register(this.form).then(res => {
            if (res.code == 0) {
              this.$message.success(res.message);
              this.$router.push("/");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goOrder() {
      this.$router.push("/user/order");
    }
  },
  mounted() {}
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: orange;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px!important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.form .input >>> .el-input__inner {
  line-height: 48px;
  height: 48px;
  border-radius: 24px;
}
.form >>> .el-input {
  width: 420px;
}
.form >>> .el-select {
  width: 420px;
}

.form >>> .el-form-item__content{
  width: 300px;
}
.form >>> .el-form-item__label{
  width: 300px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
.flex {
  display: flex;
  align-items: center;
}
.head {
  position: relative;
  margin: 44px 0 20px;
  text-align: center;
  font-size: 20px;
  p:last-child {
    position: absolute;
    top: 0;
    color: #606266;
    left: 50%;
    right: auto;
    margin-left: 14ex!important;
    margin-bottom: 4px!important;
    bottom: 0;
    line-height: 1;
    height: 20px;
    font-size: 14px;
  }
}
.title {
  font-size: 24px;
  font-weight: bold;
}
.regist-page {
  padding: 20px;
  .chose-box {
    margin: auto;
    width: 80%;
    height: 520px;
    padding: 20px;
    .head {
      margin: 44px 0 66px;
    }
    .content {
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      > div > p {
        width: 300px;
        margin-top: 20px;
        line-height: 40px;
        font-size: 20px;
        font-weight: bold;
        color: #999;
      }
      .flex {
        img,
        .title {
          margin-right: 20px;
          cursor: pointer;
        }
      }
    }
  }
  .common-btn-text {
    color: rgb(46,145,207)
  }
}
.form {
  background: #fff;
  margin: auto;
  width: 80%;
  padding: 20px;
}
</style>
